import { abbrNumberFilter, percentageSignFilter } from "app/filters/ngFilters";

export const formatNumber = abbrNumberFilter();

const percentageSignFormatter = percentageSignFilter();

export const formatPercent = (value: number, digits: number = 2) => {
    return percentageSignFormatter(value, digits);
};
